import { _ as L } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import { QUERIES as W, BREAKPOINTS as g } from "@ucl/shared-component-foundations";
import { c as w } from "./index-8b07dec9.js";
import s from "styled-components";
import "./es.object.keys-9d66766f.js";
import "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import { g as $ } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as y } from "./useWindowSize.js";
import { FocusTrap as x } from "./focusTrap.js";
import "./es.symbol.description-6025a604.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./index-f5b44da3.js";
import "./index-5d0f31c6.js";
import "./carousel.js";
import { jsx as m } from "react/jsx-runtime";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import { S as A } from "./singleSelectInput-6bdc2a66.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./array-method-is-strict-e5a3c878.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./string-trim-14e37ad3.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.parse-float-020a2ae0.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./aria.js";
import "./helperText.js";
import "./an-instance-6efcfd6c.js";
import "@ucl/shared-icons";
import "./es.array.join-c1bca812.js";
import "./uniqueId.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./index-f2264f1e.js";
import "./iconButton.js";
import "./button.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./getElementPosition-8d0dbc61.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./closeButton.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./useMediaQuery.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./divider.js";
import "./tooltip.js";
var D = ["$isDisabled"], I = /* @__PURE__ */ s.div.withConfig({
  displayName: "jumplink__TabsHeader",
  componentId: "sc-10ize1j-0"
})(["display:", ";flex-direction:", ";max-width:", ";@media ", "{max-width:", ";}"], function(e) {
  return e.theme.components.jumplink.TabsHeader.display;
}, function(e) {
  return e.theme.components.jumplink.TabsHeader.flexDirection;
}, function(e) {
  return e.theme.components.jumplink.TabsHeader.maxWidth;
}, W.tabletAndUp, function(e) {
  return e.theme.components.jumplink.TabsHeader.tabletAndUp.maxWidth;
}), z = /* @__PURE__ */ s.span.withConfig({
  displayName: "jumplink__TabWrapper",
  componentId: "sc-10ize1j-1"
})(["display:", ";width:", ";box-sizing:", ";align-items:", ";flex-shrink:", ";padding:", ";border-left:", ";&:focus-visible{outline:", ";border-radius:", ";outline-offset:", ";position:", ";z-index:", ";}border-left:", ";cursor:", ";&:hover{", "}"], function(e) {
  return e.theme.components.jumplink.TabWrapper.display;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.width;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.boxSizing;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.alignItems;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.flexShrink;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.padding;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.borderLeft;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.focusVisible.outline;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.focusVisible.borderRadius;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.focusVisible.outlineOffset;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.focusVisible.position;
}, function(e) {
  return e.theme.components.jumplink.TabWrapper.focusVisible.zIndex;
}, function(e) {
  var r = e.$isActive, n = e.theme, o = e.$isDisabled;
  return r && !o ? n.components.jumplink.TabWrapper.borderLeftActive : n.components.jumplink.TabWrapper.borderLeftInActive;
}, function(e) {
  var r = e.$isDisabled, n = L(e, D);
  return r ? n.theme.components.jumplink.TabWrapper.cursor.disabled : n.theme.components.jumplink.TabWrapper.cursor.default;
}, function(e) {
  var r = e.$isActive, n = e.$isDisabled, o = e.theme;
  return !n && "border-left:" + (r ? o.components.jumplink.TabWrapper.hover.borderLeftActive : o.components.jumplink.TabWrapper.hover.borderLeftInActive) + `;
      background-color: ` + o.components.jumplink.TabWrapper.hover.backgroundColor + `;
      cursor: ` + o.components.jumplink.TabWrapper.hover.cursor + `;
      z-index: ` + o.components.jumplink.TabWrapper.hover.zIndex + `;
      `;
}), S = /* @__PURE__ */ s.div.withConfig({
  displayName: "jumplink__TablistWrapper",
  componentId: "sc-10ize1j-2"
})([""]), C = /* @__PURE__ */ s.span.withConfig({
  displayName: "jumplink__TabLabel",
  componentId: "sc-10ize1j-3"
})(["text-align:", ";font-family:", ";font-style:", ";font-size:", ";font-weight:", ";color:", ";cursor:", ";display:", ";align-items:", ";width:", ";line-height:", ";overflow:", ";text-overflow:", ";display:", ";-webkit-line-clamp:", ";-webkit-box-orient:", ";"], function(e) {
  return e.theme.components.jumplink.TabLabel.textAlign;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.fontFamily;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.fontStyle;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.fontSize;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.fontWeight;
}, function(e) {
  var r = e.$isActive, n = e.$isDisabled, o = e.theme;
  return n ? o.components.jumplink.TabLabel.color.disabled : r ? o.components.jumplink.TabLabel.color.active : o.components.jumplink.TabLabel.color.default;
}, function(e) {
  var r = e.$isDisabled, n = e.theme;
  return r ? n.components.jumplink.TabLabel.cursor.disabled : n.components.jumplink.TabLabel.cursor.default;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.display;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.alignItems;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.width;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.lineHeight;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.overflow;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.textOverflow;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.displayWebkitBox;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.webkitLineClamp;
}, function(e) {
  return e.theme.components.jumplink.TabLabel.webkitBoxOrient;
}), Vi = function(r) {
  var n = r.activeJumpLink, o = n === void 0 ? 0 : n, u = r.setActiveJumpLink, b = r.jumplinks, a = b === void 0 ? [] : b, f = $({
    label: "JumpLink"
  }), h = y(), k = h.width, d = function(t, i) {
    t || u(i);
  }, v = function(t) {
    var i = 0;
    a.forEach(function(p, c) {
      if (p.label === (t == null ? void 0 : t.label)) {
        i = c;
        return;
      }
    }), u(i);
  }, j = function() {
    var t;
    return /* @__PURE__ */ m(A, {
      placeholder: "Select...",
      options: a.map(function(i) {
        return {
          label: i == null ? void 0 : i.label,
          value: i == null ? void 0 : i.label,
          disabled: i == null ? void 0 : i.disabled
        };
      }),
      selected: "" + ((t = a[o]) == null ? void 0 : t.label),
      onOptionSelect: v,
      size: "medium",
      maxItems: 6
    });
  }, T = function() {
    return a.map(function(t, i) {
      return i >= 8 ? null : /* @__PURE__ */ m(z, Object.assign({
        role: "tab",
        $isActive: o === i,
        "aria-selected": o === i,
        "data-focus": o === i,
        onClick: function() {
          return d(t.disabled, i);
        },
        tabIndex: o === i ? 0 : -1,
        $isDisabled: (t == null ? void 0 : t.disabled) || !1,
        className: w(["jump-link-list-item", {
          "jump-link-list-item--disabled": t == null ? void 0 : t.disabled
        }]),
        "data-index": i,
        onKeyDown: function(c) {
          return c.code === "Enter" && d(t.disabled, i);
        },
        "aria-disabled": t.disabled,
        "data-testid": "Jumplink-testid"
      }, t.accessibilityOptions, {
        children: /* @__PURE__ */ m(C, {
          $isDisabled: (t == null ? void 0 : t.disabled) || !1,
          $isActive: o === i,
          children: t.label
        })
      }), t.label.toLocaleLowerCase() + "-" + i);
    });
  };
  return /* @__PURE__ */ m(I, Object.assign({}, f, {
    children: k < g.tabletMin ? j() : /* @__PURE__ */ m(x, {
      open: !0,
      navigationType: "arrow",
      selector: ".jump-link-list-item",
      ignoredSelector: ".jump-link-list-item--disabled",
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      allowNegativeTabFocus: !0,
      allowTabDefaults: !0,
      onFocusNext: function(t, i, p) {
        return u(p ?? o);
      },
      onFocusPrevious: function(t, i, p) {
        return u(p ?? o);
      },
      children: /* @__PURE__ */ m(S, {
        role: "tablist",
        children: a && T()
      })
    })
  }));
};
export {
  Vi as JumpLink
};
